import React, { useEffect, useState } from "react";
import { individualcollectionlist } from "../../../services/admin";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export default function AllIndividualCollection() {
  const [filterProduct, setFilterProduct] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    funlist();
  }, []);

  function funlist() {
    individualcollectionlist(localStorage.getItem("branch")).then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data);
      }
    });
  }

  const columnDefs = [
    {
      headerName: "Actions",
      field: "id",
      width: 150,
      cellRenderer: function (params) {
        const userRole = localStorage.getItem("Role");
        // Show edit button only for Role=1 (admin)
        if (userRole === "1") {
          return (
            <div>
              <button
                className="btn btn-sm btn-primary"
                onClick={() => navigate(`/collection/editindividualcollection/${params.data.collection_date}/${params.data.loan_member}`)}
              >
                <i className="fa fa-edit"></i> Edit
              </button>
            </div>
          );
        }
        return null;
      },
    },
    {
      headerName: "Collection Date",
      field: "collection_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      valueFormatter: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-YYYY");
        }
      }
    },
    {
      headerName: "Member Name",
      field: "member_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone",
      field: "phone_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Loan Amount",
      field: "loan_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "right" },
      valueFormatter: function (params) {
        return params.value ? `₹${parseFloat(params.value).toFixed(2)}` : "₹0.00";
      }
    },
    {
      headerName: "EMI Total",
      field: "loan_total",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "right" },
      valueFormatter: function (params) {
        return params.value ? `₹${parseFloat(params.value).toFixed(2)}` : "₹0.00";
      }
    },
    {
      headerName: "Collection",
      field: "total_collection",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "right" },
      valueFormatter: function (params) {
        return params.value ? `₹${parseFloat(params.value).toFixed(2)}` : "₹0.00";
      }
    },
    {
      headerName: "Payment Method",
      field: "payment_method",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      valueFormatter: function (params) {
        const methods = {
          'cash': 'Cash',
          'gpay': 'GPay',
          'phonepe': 'PhonePe',
          'paytm': 'Paytm',
          'bank_transfer': 'Bank Transfer',
          'cheque': 'Cheque',
          'upi': 'UPI'
        };
        return methods[params.value] || params.value || '-';
      },
      cellStyle: function(params) {
        if (params.value === 'cash') {
          return { color: 'green', fontWeight: 'bold', textAlign: 'left' };
        } else {
          return { color: 'blue', fontWeight: 'bold', textAlign: 'left' };
        }
      }
    },
    {
      headerName: "Bank",
      field: "bank_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      valueFormatter: function (params) {
        return params.value || '-';
      }
    },
    {
      headerName: "Approval Status",
      field: "approval_status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: function(params) {
        const status = params.value || 'pending';
        let style = { textAlign: "center", fontWeight: "bold" };

        switch(status) {
          case 'approved':
            style.color = '#28a745';
            break;
          case 'rejected':
            style.color = '#dc3545';
            break;
          case 'pending':
          default:
            style.color = '#ffc107';
            break;
        }
        return style;
      },
      valueFormatter: function (params) {
        const status = params.value || 'pending';
        switch(status) {
          case 'approved':
            return 'Approved';
          case 'rejected':
            return 'Rejected';
          case 'pending':
          default:
            return 'Pending';
        }
      }
    },
    {
      headerName: "Remarks",
      field: "remarks",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  return (
    <div>
      <div className="page-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">All Individual Collections</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Collection</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              All Individual Collections
            </li>
          </ol>
        </div>
        <div className="d-flex">
          <button
            className="btn btn-primary"
            onClick={() => navigate("/collection/addindividualcollection")}
          >
            <i className="fa fa-plus me-2"></i>Add Individual Collection
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="ag-theme-alpine ag-style" style={{ height: 500 }}>
                <AgGridReact
                  rowData={filterProduct}
                  columnDefs={columnDefs}
                  pagination={true}
                  paginationPageSize={10}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
